

































































import { Component, Prop, Vue } from "vue-property-decorator";
// types
import { Player } from "@/services/players/types";
import { Solution } from "@/services/solutions/types";
import { playerValidators } from "@/components/players/playerValidators";
// service methods
import { getPlayer, updatePlayer } from "@/services/players/playerService";
import { validateForm } from "@/services/validation/validationService";
// components
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import SelectSolutionModal from "@/components/solutions/modals/SelectSolutioModal.vue";

import validate from "@/directives/validate";
    @Component({
        components: {
            SelectSolutionModal,
            HeaderActionButtons
        },
        directives: {
            validate
        }
    })
export default class PlayerCreateForm extends Vue {
        @Prop() playerId!: string;
        // local state
        player = {} as Player;
        changePlayerName = false;
        selectedSolution = {} as Solution;
        validators = playerValidators;
        // lifecycle hooks
        created() {
            this.fetchData();
        }

        // computed
        get showNameInput() : boolean {
            if ((typeof this.validators.name.state !== "undefined" || this.validators.name.state !== null) &&
                this.validators.name.state === false) {
                this.changePlayerName = true;
            }

            return this.changePlayerName;
        }

        // methods
        fetchData() {
            getPlayer(this.playerId).then(response => {
                this.player = response;
            });
        }

        async save(back: boolean) {
            if (!await validateForm([this.validators])) {
                return;
            }
            updatePlayer(this.player).then(() => {
                if (back) {
                    this.$router.push("/players");
                } else {
                    this.$router.push({ name: "updatePlayer", params: { playerId: this.player.id } });
                }
            });
        }

        back() {
            window.history.go(-1);
        }

        removeSolution() {
            this.selectedSolution = {} as Solution;
            this.player.solutionId = "";
        }

        openSolutionModal() {
            (this.$refs.selectSolutionModal as any).open([], true);
        }

        onSelected(solutions: Solution[]) {
            this.selectedSolution = solutions[0];
            this.player.solutionId = solutions[0].id;
        }

        toggleName() {
            // if input is invalid do nothing
            if (typeof this.validators.name.state !== "undefined" &&
                this.validators.name.state === false) {
                return;
            }

            this.changePlayerName = false;
        }
}
